import { AnyAction } from "redux";
import { IPAInsuranceState, initialPAInsuranceState } from "./paInsurance.state";

export const paInsuranceReducer = (
  state: IPAInsuranceState = initialPAInsuranceState,
  action: AnyAction
): IPAInsuranceState => {
  switch (action.type) {
    default:
      return state;
  }
};
